import doMatchedRoutesMatch from 'app/common/middlewares/utils/doMatchedRoutesMatch';

const isAuthAttemptRequiredForMatchedRoutes = doMatchedRoutesMatch(route => {
  return !!route.isAuthAttemptRequired;
});

export default isAuthAttemptRequiredForMatchedRoutes;
